// extracted by mini-css-extract-plugin
module.exports = {"container":"authFooter_container__1lxg7","app_version":"authFooter_app_version__20Km0","ball_gradient_footer":"authFooter_ball_gradient_footer__1wI36"};